"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var validation_const_1 = require("../const/validation.const");
function isAlphanumeric(value) {
    var stringifiedValue = lodash_1.isNumber(value) ? lodash_1.toString(value) : value;
    return validation_const_1.VALIDATION_PATTERN.alphanumeric.test(stringifiedValue);
}
exports.isAlphanumeric = isAlphanumeric;
function isAscii(value) {
    var stringifiedValue = lodash_1.isNumber(value) ? lodash_1.toString(value) : value;
    return validation_const_1.VALIDATION_PATTERN.ascii.test(stringifiedValue);
}
exports.isAscii = isAscii;
function isWeakPassword(value) {
    var stringifiedValue = lodash_1.isNumber(value) ? lodash_1.toString(value) : value;
    return validation_const_1.VALIDATION_PATTERN.weakPassword.test(stringifiedValue);
}
exports.isWeakPassword = isWeakPassword;
function isMediumPassword(value) {
    var stringifiedValue = lodash_1.isNumber(value) ? lodash_1.toString(value) : value;
    return validation_const_1.VALIDATION_PATTERN.mediumPassword.test(stringifiedValue);
}
exports.isMediumPassword = isMediumPassword;
function isStrongPassword(value) {
    var stringifiedValue = lodash_1.isNumber(value) ? lodash_1.toString(value) : value;
    return validation_const_1.VALIDATION_PATTERN.strongPassword.test(stringifiedValue);
}
exports.isStrongPassword = isStrongPassword;
function isEmail(value) {
    if (!value && !lodash_1.isString(value)) {
        return false;
    }
    return validation_const_1.VALIDATION_PATTERN.email.test(value);
}
exports.isEmail = isEmail;
function isMinLength(value, length) {
    if (length === void 0) { length = 3; }
    var stringifiedValue = lodash_1.isNumber(value) ? lodash_1.toString(value) : value;
    return stringifiedValue.length >= length;
}
exports.isMinLength = isMinLength;
function isPattern(value, pattern) {
    var stringifiedValue = lodash_1.isNumber(value) ? lodash_1.toString(value) : value;
    if (!pattern) {
        return true;
    }
    return pattern.test(stringifiedValue);
}
exports.isPattern = isPattern;
